import { FC } from "react";
import { MainLogo } from "@/components/Common/MainLogo/MainLogo";
import { MainMenu } from "@/components/Common/MainMenu/MainMenu";
import { MobileNav } from "@/components/Common/MobileNav/MobileNav";
import { AppHeaderActions } from "@/components/Common/AppHeader/AppHeaderActions";
import { useAuthState } from "@/store/auth";

export const ExplorerHeader: FC = () => {
  const isLoggedIn = useAuthState((state) => state.status === "authenticated");

  return (
    <div className="sticky top-0 z-30 bg-gray-dark-600">
      {/* <MaintenanceAnnouncementBanner /> */}
      <div
        className="flex flex-row items-center gap-1 px-6 py-3 pl-5 dark:border-b-gray-dark-500 md:gap-3"
        data-testid={"ExplorerHeader_wrapper"}
      >
        <MainLogo isLoggedIn={isLoggedIn} />

        <div className="flex flex-1 flex-row items-center justify-end gap-1 md:gap-3">
          <AppHeaderActions />
        </div>

        <div className="lg:hidden">
          <MobileNav />
        </div>
      </div>
      <MainMenu />
    </div>
  );
};
